import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.scss']
})
export class ConfirmationComponent {
  @Input() showConfirmationModal:boolean = false;
  @Input() confirmationMessage:string = "";
  @Output() closeConfirmation = new EventEmitter<boolean>();
  @Output() confirm = new EventEmitter<boolean>();


  closeConfirmationModal(){
    this.closeConfirmation.emit(true);
  }

  confirmation(){
    this.confirm.emit(true);
  }
}
